// extracted by mini-css-extract-plugin
export const flexStyle = "paymentMethods-module--flexStyle--3yPua";
export const image = "paymentMethods-module--image--3qZJZ";
export const title = "paymentMethods-module--title--u79RB";
export const border = "paymentMethods-module--border--nDALT";
export const imagePay = "paymentMethods-module--image-pay--2Fxht";